import { Dropdown, DropdownItem, KebabToggle } from '@patternfly/react-core'
import { Tr, Td } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import type { IDomainEvent } from '@app/domain/domain-events/domain-events.interface'
import * as DomainEventState from '@app/state/domain-events/state'

interface Props {
  className?: string
  domainEvent: IDomainEvent
  expandedRows: { [key: string]: boolean }
  handleExpanded: (domainEventId: string) => void
  index: number
}

const dropdownItems = [
  <DropdownItem key="resubmit" value="resubmit" component="button">
    Resubmit
  </DropdownItem>,
]

export const BroadcastFailureHeader = function ({
  domainEvent,
  expandedRows,
  handleExpanded,
  index,
}: Props) {
  const dispatch = useDispatch()

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleToggle = useCallback(() => {
    setIsMenuOpen(!isMenuOpen)
  }, [isMenuOpen])

  const handleSelect = useCallback(
    (event) => {
      const value = event.target.getAttribute('value')

      if (value === 'resubmit') {
        dispatch(DomainEventState.actions.resubmitDomainEvent(domainEvent.id))
      }
      setIsMenuOpen(false)
    },
    [dispatch, domainEvent],
  )

  const handleExpansionToggle = useCallback(() => {
    handleExpanded(domainEvent.id)
  }, [domainEvent, handleExpanded])

  return (
    <Tr>
      <Td
        key={`${index}_0`}
        expand={{
          rowIndex: index,
          isExpanded: expandedRows[domainEvent.id] ?? false,
          onToggle: handleExpansionToggle,
        }}
       />
      <Td>{domainEvent.type}</Td>
      <Td>{domainEvent.source}</Td>
      <Td>{domainEvent.subject}</Td>
      <Td>{domainEvent.time}</Td>
      <Td>
        <Dropdown
          onSelect={handleSelect}
          toggle={<KebabToggle onToggle={handleToggle} id="toggle-id-6" />}
          isOpen={isMenuOpen}
          isPlain
          dropdownItems={dropdownItems}
        />
      </Td>
    </Tr>
  )
}
